import { useQuery } from 'react-query';
import { getTrialEligibility } from '../api/subscription.api';
import { getDataFromResponse } from '../../../core/constant/utils/react-query-utils/getDataFromResponse';

export const useTrialEligibilityQuery = (memberId: string | undefined, enabled: boolean = true) => {
  return useQuery(
    ['trialEligibility', memberId],
    async ({ signal }) => {
      if (!memberId) {
        throw new Error('Member ID is required');
      }
      const response = await getTrialEligibility(memberId, signal);
      return getDataFromResponse(response);
    },
    {
      enabled: enabled && !!memberId,
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
      retry: 1,
    }
  );
};
